/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileContentModuleRegular_browseContentModule = {
    readonly description: string | null;
    readonly " $refType": "SbMobileContentModuleRegular_browseContentModule";
};
export type SbMobileContentModuleRegular_browseContentModule$data = SbMobileContentModuleRegular_browseContentModule;
export type SbMobileContentModuleRegular_browseContentModule$key = {
    readonly " $data"?: SbMobileContentModuleRegular_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileContentModuleRegular_browseContentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbMobileContentModuleRegular_browseContentModule",
  "type": "ContentModuleRegular",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '5e717fb7359ad79e68e46e4270094f17';
export default node;
